import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";

// Lazy load below-the-fold sections to reduce initial bundle size
const PrayerTimesSection = lazy(() => import("@/components/PrayerTimesSection"));
const DonationSection = lazy(() => import("@/components/DonationSection"));

const AnnouncementsSection = lazy(() => import("@/components/AnnouncementsSection"));
const ServicesSection = lazy(() => import("@/components/ServicesSection"));
const ContactSection = lazy(() => import("@/components/ContactSection"));
const DirectionsSection = lazy(() => import("@/components/DirectionsSection"));
const Footer = lazy(() => import("@/components/Footer"));

const SectionFallback = () => (
  <div className="min-h-[200px] flex items-center justify-center">
    <div className="animate-pulse text-muted-foreground">Loading...</div>
  </div>
);

const Index = () => {
  return (
    <main className="min-h-screen bg-background">
      <Navbar />
      
      <header>
        <HeroSection />
      </header>
      
      <Suspense fallback={<SectionFallback />}>
        {/* Prayer Times - Immersive full-screen experience */}
        <section id="prayer-times" aria-label="Prayer Times">
          <PrayerTimesSection />
        </section>
        
        {/* Announcements - Keep community informed */}
        <section id="announcements" aria-label="Announcements">
          <AnnouncementsSection />
        </section>
        
        {/* Donation - Support the mesjid */}
        <section id="donate" aria-label="Donate">
          <DonationSection />
        </section>
        
        {/* Services - What we offer */}
        <section id="services" aria-label="Services">
          <ServicesSection />
        </section>
        
        {/* Contact & Directions - How to reach us */}
        <section id="contact" aria-label="Contact">
          <ContactSection />
        </section>
        
        <section id="directions" aria-label="Directions">
          <DirectionsSection />
        </section>
        
        <Footer />
      </Suspense>
    </main>
  );
};

export default Index;
